// extracted by mini-css-extract-plugin
module.exports = {"new-tag":"new-tag-1gei6","newTag":"new-tag-1gei6"};